<template>
    <section class="bonusomat-slots">
        <TypographyHeadline v-if="isWidget" class="bonusomat-slots__headline" type="section" theme="dark">
            <div v-if="isWidget" class="games-headline">
                <WebpImage
                    src="/frontend/web/img/casino/icons/gift-green.png"
                    alt=""
                    class="games-headline__icon games-headline__icon--gift-green"
                    :isLazyload="true"
                    :width="24"
                    :height="24"
                />
                <h3 class="games-headline__title">Bonusomat</h3>
            </div>
            <span v-else>Bonusomat</span>
            <DsButton
                v-if="!isWidget"
                type="text"
                theme="dark"
                icon-right="help"
                @click="openBonusomatOnboardingClick"
                class="button-onboarding"
            />
            <DsButton v-if="!isWidget" theme="dark" type="interaction" size="sm" icon-right="gift" @click="openModal">
                Tabulka výher
            </DsButton>
            <DsButton
                v-if="isWidget"
                theme="dark"
                type="interaction"
                size="sm"
                icon-right="arrow-right"
                href="/hry/bonusomat"
                @click="GamesAnalytics.pushClickBonusomat(bonusomatPlayerData.points)"
            >
                Přejít k bonusomatu
            </DsButton>
        </TypographyHeadline>
        <div class="bonusomat-slots__left">
            <WebpImage
                :src="slotsMainImageUrl"
                :alt="slotsMainImageAlt"
                :css-class="[
                    'bonusomat-slots__image',
                    {
                        'bonusomat-slots__image--hide-on-mobile': !isWidget,
                        'bonusomat-slots__image--widget-with-spin': isWidget && isSpinAvailable,
                    },
                ]"
            />
        </div>
        <div class="bonusomat-slots__right">
            <TypographyHeadline v-if="!isWidget" class="bonusomat-slots__headline" type="section" theme="dark">
                <div v-if="isWidget" class="games-headline">
                    <WebpImage
                        src="/frontend/web/img/casino/icons/gift-green.png"
                        alt=""
                        class="games-headline__icon games-headline__icon--gift-green"
                        :isLazyload="true"
                        :width="24"
                        :height="24"
                    />
                    <h3 class="games-headline__title">Bonusomat</h3>
                </div>
                <span v-else>Bonusomat</span>
                <DsButton
                    v-if="!isWidget"
                    type="text"
                    theme="dark"
                    icon-right="help"
                    @click="openBonusomatOnboardingClick"
                    class="button-onboarding"
                />
                <DsButton
                    v-if="!isWidget"
                    theme="dark"
                    type="interaction"
                    size="sm"
                    icon-right="gift"
                    @click="openModal"
                >
                    Tabulka výher
                </DsButton>
                <DsButton
                    v-if="isWidget"
                    theme="dark"
                    type="interaction"
                    size="sm"
                    icon-right="arrow-right"
                    href="/hry/bonusomat"
                    @click="GamesAnalytics.pushClickBonusomat(bonusomatPlayerData.points)"
                >
                    Přejít k bonusomatu
                </DsButton>
            </TypographyHeadline>

            <div v-if="isWidget && !isLoggedIn">
                <BonusomatRaffleCountersGroup
                    :hasRaffleDataLoadingFailed="isLogoutDefaultDrawDataLoaded && !logoutDefaultDrawData"
                    :showDefaultCounters="true"
                    :totalWin="logoutDefaultDrawData?.totalWin"
                    :raffleRemainingSeconds="logoutDrawRemainingSeconds"
                    :showAllwynCounters="false"
                    :showTicketsCounters="false"
                    :isWidget="isWidget"
                />
            </div>
            <div
                v-else
                class="bonusomat-slots__action-bar"
                :class="{
                    'bonusomat-slots__action-bar--inactive': isInactive,
                    'bonusomat-slots__action-bar--spin': isSpinAvailable,
                    'bonusomat-slots__action-bar--error': playerDataHasError,
                    'bm-slots-bar-sticky-on-mobile': !isWidget,
                }"
                ref="slotsBar"
            >
                <WebpImage
                    :src="bonImgUrl('slots/bonusomat-slots', 'png')"
                    alt="Bonusomat"
                    class="bonusomat-slots__bar-image"
                />
                <DsIcon name="b-mat" class="bonusomat-slots__bar-icon" />

                <div class="bonusomat-slots__group" v-if="isPlayerDataLoaded">
                    <div class="bonusomat-slots__text" v-if="playerDataHasError">
                        Omlouváme se, při načítání bodů nastala chyba.
                    </div>
                    <template v-else-if="isInactive">
                        <div class="bonusomat-slots__text">
                            <span>{{ slotsActiveQuestText }}</span>
                            <br />
                            <span class="bonusomat-slots__text--thin"> je Bonusomat neaktivní</span>
                        </div>
                        <DsButton size="sm" type="error" icon-right="cross" @click="deactivateQuest('main')">
                            Ukončit Quest
                        </DsButton>
                    </template>

                    <template v-else-if="isSpinAvailable">
                        <div class="bonusomat-slots__text">
                            <span class="bonusomat-slots__text--thin">K dispozici</span>
                            {{ remainingSpinsCount }}&nbsp;zatočení
                        </div>
                        <DsButton size="sm" icon-right="rotate" @click="spinModalIsOpen = !spinModalIsOpen">
                            Získat odměnu
                        </DsButton>
                    </template>

                    <template v-else>
                        <div class="bonusomat-slots__text">
                            <span class="bonusomat-slots__text--gray"> {{ fulfilledTextInclined }} </span>
                            <br />
                            {{ bonusomatPlayerData.points }}&nbsp;z&nbsp;5&nbsp;úkolů
                        </div>
                        <div class="bonusomat-slots__points">
                            <div
                                class="bonusomat-slots__point bonusomat-slots__point--completed"
                                v-for="index in bonusomatPlayerData.points"
                                :key="index"
                            >
                                <DsIcon name="check" />
                            </div>
                            <div
                                class="bonusomat-slots__point"
                                v-for="index in 5 - bonusomatPlayerData.points"
                                :key="index"
                            >
                                {{ bonusomatPlayerData.points + index }}
                            </div>
                        </div>
                    </template>
                </div>
                <div class="bonusomat-slots__group" v-else>
                    <div class="bonusomat-slots__text">
                        <div class="bonusomat-slots__text--placeholder bonusomat-placeholder__skeleton"></div>
                        <div class="bonusomat-slots__text--placeholder bonusomat-placeholder__skeleton"></div>
                    </div>
                    <div class="bonusomat-slots__points">
                        <div
                            class="bonusomat-slots__point bonusomat-slots__point--placeholder bonusomat-placeholder__skeleton"
                            v-for="index in 5"
                            :key="index"
                            :style="{
                                animationDelay: `${0.2 + index * 0.1}s`,
                            }"
                        ></div>
                    </div>
                </div>
            </div>
        </div>

        <DsModalDialog
            v-model="isModalOpen"
            :css-class="['bonusomat-win-table', slotsWinTable?.jokerSection ? 'bonusomat-win-table--with-joker' : '']"
            theme="dark"
        >
            <template #top>
                <DsTopSlotHeadlineSubheadline :headline="slotsWinTable?.title" />
                <p class="bonusomat-win-table__description" v-html="slotsWinTable?.description"></p>
            </template>
            <template #content>
                <h3 class="bonusomat-win-table__label">Co můžete vyhrát?</h3>
                <div class="bonusomat-win-table__tables">
                    <div class="bonusomat-win-table__section-grid">
                        <BonusomatSlotsWinTable
                            v-for="(section, index) in slotsWinTable?.sections"
                            :key="index"
                            :show-header="index === 0 || (index === 1 && isFoldable)"
                            :row-one-text="section.row1.text"
                            :row-one-image="section.row1.image"
                            :row-two-text="section.row2.text"
                            :row-two-image="section.row2.image"
                            :row-three-text="section.row3.text"
                            :row-three-image="section.row3.image"
                        />
                    </div>
                    <div class="bonusomat-win-table__section-joker" v-if="slotsWinTable?.jokerSection">
                        <BonusomatSlotsWinTable
                            :show-header="true"
                            :row-one-text="slotsWinTable.jokerSection.row1.text"
                            :row-one-image="slotsWinTable.jokerSection.row1.image"
                            :row-two-text="slotsWinTable.jokerSection.row2.text"
                            :row-two-image="slotsWinTable.jokerSection.row2.image"
                            :row-three-text="slotsWinTable.jokerSection.row3.text"
                            :row-three-image="slotsWinTable.jokerSection.row3.image"
                        />
                        <div class="bonusomat-win-table__allwyn-joker-img-wrap">
                            <WebpImage
                                src="/frontend/web/img/logos/allwyn/allwyn-joker-logo-white.svg"
                                alt="allwyn Joker logo"
                            />
                        </div>
                    </div>
                </div>
            </template>
            <template #bottom>
                <DsBottomSlotActionBar :has-btn-close="false" :has-btn-submit="false">
                    <template #additional>
                        <MobileAppLink
                            :href="slotsWinTable.rules"
                            target="_blank"
                            event-name="openPdf"
                            :event-argument="slotsWinTable.rules"
                            class="bonusomat-win-table__button-rules button button--primary button--dark button--sm button--icon"
                            icon-right="arrow-right-thin"
                            :open-in-new-tab="true"
                            @link-clicked="
                                BonusomatDatalayer.pushClickWinRules(bonusomatPlayerData.points, remainingSpinsCount)
                            "
                            >Kompletní pravidla</MobileAppLink
                        >
                    </template>
                </DsBottomSlotActionBar>
            </template>
        </DsModalDialog>

        <BonusomatSpinModal v-model="spinModalIsOpen" @open-win-table="openModal" />
    </section>
    <div v-if="isWidget" class="bonusomat-slots-bg"></div>
</template>

<script lang="ts" setup>
import { computed, ref, onMounted, watch } from "vue";
import DsBottomSlotActionBar from "@sazka/design-system/src/bottom-slot/ds-bottom-slot-action-bar.vue";
import DsButton from "@sazka/design-system/src/button/ds-button.vue";
import DsIcon from "@sazka/design-system/src/icon/ds-icon.vue";
import WebpImage from "@sazka/design-system/src/image/webp-image.vue";
import DsModalDialog from "@sazka/design-system/src/modal-dialog/ds-modal-dialog.vue";
import DsTopSlotHeadlineSubheadline from "@sazka/design-system/src/top-slot/ds-top-subheadline.vue";
import TypographyHeadline from "@sazka/design-system/src/typography/typography-headline.vue";
import MobileAppLink from "@sazka/mobile-apps/components/mobile-app-link.vue";
import { useBreakpoints } from "@sazka/utils/composables/use-breakpoints";
import { sazkaAlert } from "@sazka/utils/sazka-alert";
import { UrlUtils } from "@sazka/utils/url";
import { BonusomatDatalayer } from "@/casino/bonusomat/utils/analytics/bonusomat-datalayer";
import { GamesAnalytics } from "@/games/analytics/analytics-games";
import { useLoyaltyPlayerStatus } from "@/loyalty/composables/use-loyalty-player-status";
import BonusomatSlotsWinTable from "./bonusomat-slots-win-table.vue";
import BonusomatSpinModal from "./bonusomat-spin-modal.vue";
import useBonusomatData from "../../composables/use-bonusomat-data";
import useBonusomatLogoutCountdown from "../../composables/use-bonusomat-logout-countdown";
import useBonusomatLogoutData from "../../composables/use-bonusomat-logout-data";
import useBonusomatOnboarding from "../../composables/use-bonusomat-onboarding";
import useBonusomatSlotsBar from "../../composables/use-bonusomat-slots-bar";
import useBonusomatWinTables from "../../composables/use-bonusomat-win-tables";
import { bonImgUrl } from "../../utils/image-src";
import BonusomatRaffleCountersGroup from "../raffle/bonusomat-raffle-counters-group.vue";

const { bonusomatPlayerStatus } = useLoyaltyPlayerStatus();
const { bonusomatPlayerData, remainingSpinsCount, playerDataHasError, isPlayerDataLoaded, fulfilledTextInclined } =
    bonusomatPlayerStatus;

const { hasActiveQuest, deactivateQuest } = useBonusomatData();

const { openBonusomatOnboarding, setOnboardingAlreadyVisited } = useBonusomatOnboarding();

const { slotsWinTable, loadSlotsWinTable } = useBonusomatWinTables();

const { logoutDefaultDrawData, isLogoutDefaultDrawDataLoaded, loadDefaultDrawData } = useBonusomatLogoutData();
const { logoutDrawRemainingSeconds } = useBonusomatLogoutCountdown();

const { slotsBarSticky } = useBonusomatSlotsBar();

const isFoldable = useBreakpoints("sm");
const isLaptop = useBreakpoints("sm2");

const props = defineProps<{
    isWidget?: boolean;
    isLoggedIn?: boolean;
}>();

const slotsBar = ref<HTMLElement>(null);

if (props.isWidget && !props.isLoggedIn) {
    loadDefaultDrawData();
}

const spinModalIsOpen = ref(false);

const isSpinAvailable = computed(() => {
    return remainingSpinsCount.value > 0 && isPlayerDataLoaded.value;
});
const slotsMainImageUrl = computed(() => {
    return props.isWidget && !isSpinAvailable.value
        ? bonImgUrl("automat/automat", "png", "v=1")
        : bonImgUrl("slots/mr-green-bonusomat", "png");
});
const slotsMainImageAlt = computed(() => {
    return props.isWidget ? "Bonusomat" : "Pan Zelený stojící vedle Bonusomatu";
});
const slotsActiveQuestText = computed(() => {
    return isLaptop.value ? "Po dobu hraní Questu" : "Během Questu";
});
const isInactive = computed(() => {
    return hasActiveQuest.value && remainingSpinsCount.value === 0 && isPlayerDataLoaded.value;
});

const isModalOpen = ref(false);

const openModal = async () => {
    try {
        if (slotsWinTable.value) return;

        await loadSlotsWinTable();
    } catch (error) {
        sazkaAlert("Omlouváme se, při načítání tabulky výher nastala chyba.", "Zkuste to prosím později.");
    } finally {
        if (slotsWinTable.value) {
            isModalOpen.value = true;
        }

        BonusomatDatalayer.pushMoreInfoClick(
            "Tabulka výher",
            bonusomatPlayerData.value.points,
            remainingSpinsCount.value
        );
    }
};

const openBonusomatOnboardingClick = () => {
    openBonusomatOnboarding("slots");
    BonusomatDatalayer.pushMoreInfoClick("Bonusomat", bonusomatPlayerData.value.points, remainingSpinsCount.value);
};

const openSpinModalQueryParamName = "slots";
const queryParams = new URLSearchParams(window.location.search);
if (queryParams.has(openSpinModalQueryParamName)) {
    setOnboardingAlreadyVisited();

    UrlUtils.clearUrlParams([openSpinModalQueryParamName]);
    spinModalIsOpen.value = true;
}

onMounted(() => {
    if (!props.isWidget) {
        slotsBarSticky(slotsBar.value, true);
    }
});

watch(
    bonusomatPlayerData,
    () => {
        if (props.isWidget) {
            GamesAnalytics.pushShowBonusomat(bonusomatPlayerData.value.points);
        }
    },
    { once: true }
);
</script>
